import { context } from '../../config';
var tokenInterceptor = function tokenInterceptor(config) {
  var session = context().session;
  if (!session) {
    return Promise.resolve(config);
  }
  return session.getToken().then(function (token) {
    config.headers.Authorization = "Bearer ".concat(token);
    return config;
  }).catch(function () {
    return config;
  });
};
export default tokenInterceptor;